import { Play, Apple } from "lucide-react";
import { useSite } from "@/context/SiteContext";

export function StoreButtons({ className = "", size = "default" }) {
  const { settings } = useSite();
  const gp = settings.google_play_url;
  const as = settings.app_store_url;
  const pad = size === "lg" ? "px-6 py-4" : "px-5 py-3.5";

  return (
    <div className={`flex flex-col sm:flex-row gap-3 ${className}`}>
      <a
        data-testid="download-google-play-btn"
        href={gp || "#"}
        target={gp ? "_blank" : undefined}
        rel="noopener noreferrer"
        className={`group inline-flex items-center gap-3 ${pad} rounded-full bg-[#D4AF37] text-[#0F2F1D] font-semibold transition-all hover:bg-[#C59B27] hover:-translate-y-0.5 shadow-lg shadow-[#D4AF37]/20`}
      >
        <Play className="h-5 w-5 fill-current" />
        <span className="text-left leading-tight">
          <span className="block text-[10px] font-mono-accent uppercase tracking-wider opacity-70">Şimdi indir</span>
          Google Play
        </span>
      </a>
      <a
        data-testid="download-app-store-btn"
        href={as || undefined}
        aria-disabled={!as}
        className={`inline-flex items-center gap-3 ${pad} rounded-full border border-white/25 text-white font-semibold transition-all ${
          as ? "hover:bg-white/10 hover:-translate-y-0.5" : "opacity-45 cursor-not-allowed"
        }`}
      >
        <Apple className="h-5 w-5" />
        <span className="text-left leading-tight">
          <span className="block text-[10px] font-mono-accent uppercase tracking-wider opacity-60">{as ? "Şimdi indir" : "Yakında"}</span>
          App Store
        </span>
      </a>
    </div>
  );
}
